module.exports = __webpack_public_path__ + "img/signup-bg4.4b60c8a0.png";